exports.connect = {
	url: "https://api.campingaiguillecreuse.camp/"
}
